import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import * as qs from "query-string";
import "./assets/styles/core.scss";
import { useLocation } from "react-router-dom";
import Loading from "./Components/Loading";
import parameters from "./config/parameters";

function App() {
  // eslint-disable-next-line
  const [cookies, setCookies] = useCookies();
  const location = useLocation();

  const queries = qs.parse(location.search);
  const { subscription } = queries;

  useEffect(() => {
    // data.MSISDN = " 213556031038";
    fetch(`${parameters.notifApi}`)
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        const { data } = res;
        if (data.msisdn) {
          const phone = data.msisdn.replace(/\s/g, "");
          setCookies("MSISDN", `${phone}`, { domain: parameters.ooredooPath });
        } else {
          setCookies("MSISDN", "", { domain: parameters.ooredooPath });
        }
      });
  }, [setCookies]);

  useEffect(() => {
    setTimeout(() => {
      window.location.replace(
        `${parameters.paiementUrl}/paiement?subscription=${subscription}`
      );
    }, parameters.waitingTime);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {}, []);
  return <Loading />;
}

export default App;
